import { Col, Row } from "antd";
import ProgrammeCard from "../cards/ProgrammeCard";
import {programmes} from "../../utils/apiConstants"; 

export const ProgrammesView = () => {
 
  return (
    // <>
    <div className="programme-background">
      <Row style={{ paddingBottom: 30, paddingTop: 10 }}>
        <Col xs={24}>
        <div className="public-portal-programme">
          <h2>SEIMS Initiatives</h2>
        </div>
          <Row gutter={[16, 16]} className="card-section programme-card-row">
            {programmes.map((item, index) => (
              <Col key={"Programme-" + index} xs={24} md={12} lg={6} className="programme-card-col">
                <ProgrammeCard programme={item} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
    // </>
  );
};
